import {formatDate} from "xmgoing-utils";
import jsParse from "@/main-page/jsParseEngine/jsParse";

function getSystemVal(val) {
  switch (val) {
    case 'currentYear':
      return formatDate(new Date(), {format: 'yyyy'});
    case 'currentYearMonth':
      return formatDate(new Date(), {format: 'yyyy-MM'});
    case 'currentDate':
      return formatDate(new Date(), {format: 'yyyy-MM-dd'});
    case 'currentWeek':
      return;
    case 'currentMonth':
      return formatDate(new Date(), {format: 'MM'});
    default :
      break;
  }
}

/**
 * 初始化查询参数
 * @param queryParams
 * @param params
 * @param pageModelsStore
 */
export function initParamsByQueryParams(queryParams, params, pageModelsStore) {
  queryParams.forEach((queryItem) => {
    const {from, key, value,subPropId} = queryItem;
    //从状态机获取
    if (from === 'vuex') {
      if (pageModelsStore) {
        params[key] = pageModelsStore.state[value] || '';
      }
      if(typeof(pageModelsStore.state[value])==='object'&&subPropId){
        params[key] = pageModelsStore.state[value][subPropId];
      }
    }
    //从输入中获取
    if (from === 'input') {
      params[key] = value || '';
    }
    //从系统参数中获取
    if (from === 'system') {
      params[key] = getSystemVal(value) || '';
    }
  })
}

/**
 * 参数处理
 * @param params
 * @param paramsDeal
 */
export function initParamsByParamsDealStr(params,paramsDeal){
  const fun = jsParse.NewPublicFunction(paramsDeal)();
  return fun(params);
}

/**
 * 错误处理函数
 * @param error
 * @param errorDeal
 */
export  function initErrorDealStr(error,errorDeal){
  const fun = jsParse.NewPublicFunction(errorDeal)();
  return fun(error);
}

/**
 * 初始化成功处理函数
 * @param res
 * @param successDeal
 */
export function initSuccessDealDealStr(res,successDeal,pageModelsStore){
  const fun = jsParse.NewPublicFunction(successDeal)();
  return fun(res,pageModelsStore.state);
}
